import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';

import css from './ListingPage.module.css';
import BrandIconCard from '../../components/BrandIconCard/BrandIconCard';

const SectionReviews = props => {
  const { reviews, uperReview, fetchReviewsError } = props;

  const totalRating = reviews.reduce((sum, review) => sum + review.attributes.rating, 0);
  const averageRating = reviews.length > 0 ? totalRating / reviews.length : 0;
  const roundedRating = Math.round(averageRating);

  return (
    <section className={css.sectionReviews}>
      {!uperReview && 
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        {/* <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews?.length }} /> */}
        <FormattedMessage id="ListingPage.customerReviews"/>
      </Heading>
      }
      <div className={css.ratingSection}>
        <span className={css.ratingStar}>
          <BrandIconCard type="star" />
         {uperReview ? roundedRating :reviews?.length}
        </span>
        <span className={css.reviewSubHeading}>
          <span className={css.dotRound} /> {reviews?.length} Reviews
        </span>
      </div>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      {!uperReview && <Reviews reviews={reviews} />}
    </section>
  );
};

export default SectionReviews;
